import React, {useEffect, useState} from "react";
import LoadingSpinner from "./LoadingSpiner";
import {createXML} from "./createFISxml";
import {createParaFISxml} from "./createParaFISxml";

function MakeFISXML(props) {
  const data = props.csvData;
  const jurry = props.jurry;
  const headerInfo = props.headerInfo;

  const [xmlURL, setxmlURL] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const checkForCorectSex = () =>{
    /**
     go through the racers and find the sex/gender. then match that sex to the
     one selected in the header info. if they dont match then alert the
     user to change the sex for the file.
    **/
     console.log('data trying to find sex:', data)
     let raceSex = ''

     // Check for various possible gender column names
     const genderColumns = ['sex', 'Gender', 'gender', 'Sex']
     data.forEach(racer => {
       for (const col of genderColumns) {
         if(racer[col]){
           let genderValue = racer[col].toLowerCase().trim()
           // Convert to standard format
           if (genderValue === 'male' || genderValue === 'm') {
             raceSex = 'M'
           } else if (genderValue === 'female' || genderValue === 'f') {
             raceSex = 'W'
           } else if (genderValue === 'team' || genderValue === 'a') {
             raceSex = 'A'
           } else {
             raceSex = genderValue.toUpperCase()
           }
           return
         }
       }
     });

     let headerInfoSex = headerInfo.sex
     console.log('Race sex found:', raceSex, 'Header sex:', headerInfoSex)

     return raceSex === headerInfoSex || raceSex === ''

  }

  // downloads the XML file
  const DownloadXML = () => {
    if(!checkForCorectSex()){
      window.alert('Sex in the header info does not match the sex of the racers in the File you uploaded')
      return
    }
    setIsLoading(true);
    // download the XML file
    if (headerInfo.sector && headerInfo.sector !== "CC") {
        createParaFISxml(headerInfo, data, jurry, setxmlURL);
    } else {
        createXML(headerInfo, data, jurry, setxmlURL);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 100);
  };

  // helper for downloading the xml
  useEffect(() => {
    const handleDownload = () => {
      // Use the HTMLAnchorElement to download the file
      const downloadLink = document.createElement("a");
      downloadLink.href = xmlURL;
      downloadLink.download = `${headerInfo.codex || "FIS_XML_Results"}.xml`;
      // document.body.appendChild(downloadLink);
      // downloadLink.click();
      // document.body.removeChild(downloadLink);
      document.getElementById('hiddenDownloadLinkFIS').appendChild(downloadLink);
      downloadLink.click()

      setxmlURL("")
    };
    if (data && data.length > 0 && xmlURL) {
      handleDownload();
    }
  }, [xmlURL, data, headerInfo.title]);

  return (
    <>
      <button id="downloadButton" onClick={DownloadXML} disabled={!data || !(data.length > 0)}>
        {isLoading ? <LoadingSpinner /> : "Download XML"}
      </button>
      <div id='hiddenDownloadLinkFIS' style={{display:"none"}}></div>
    </>
  );
}

export default MakeFISXML;
